import React from 'react'
// Live Services
import i18n from 'live/services/i18n'
import EditorService from 'live/services/editor'
import widgetsService from 'live/services/widgets'

import { withSuspenseWrapper } from '../../components/SuspenseWrapper'

import { reactWidgetWrapper } from 'live/widgets/decorators/react'
import WidgetReducer from './reducers/index'

const WrapperEditor = withSuspenseWrapper(React.lazy(() => import('./multi-kpis-editor')))
const WrapperMultiKpisImpl = withSuspenseWrapper(React.lazy(() => import('./multi-kpis')))

export const REDUCER_LATEST = '@latest'

const policies = {
    legends: false,
    restrictViewModeOptionsHeight: true,
    allowHideTooltip: false,
    handleOwnMissingData: true,
    allowXAxisConfig: false,
    allowYAxisConfig: false
}

const widgetType = 'multi-kpis'

const DEFAULT_CHART_CONFIG = {
    spanFinal: false,
    chartConfig: {}
}

widgetsService.impl(widgetType, reactWidgetWrapper(WrapperMultiKpisImpl, WidgetReducer))
widgetsService.queryHandlerKind(widgetType, widgetType)
widgetsService.config(widgetType, DEFAULT_CHART_CONFIG)
widgetsService.policies(widgetType, policies)

const EditorInfo = {
    order: 15,
    type: `${widgetType}-editor`,
    label: 'Histogram for KPIs',
    description: i18n('Histogram for Rigs and Wells Performance'),
    iconClass: 'far fa-tasks'
}

EditorService.newEditor({
    name: EditorInfo.type,
    editor: WrapperEditor,
    defaultWidgetType: widgetType
})

EditorService.newEditorMenuOption(widgetType, EditorInfo)

widgetsService.editor(widgetType, EditorInfo.type)
widgetsService.ui(widgetType, { editor: EditorInfo.type })
